import styles from "./Row.module.sass";
import cn from "classnames";
import Checkbox from "../../../../components/Checkbox";
import { useNavigate } from "react-router-dom";
import { getOfferById } from "../../../../services/offer.service";

// Fonction pour formater la date
const formatDate = (dateString) => {
  if (!dateString) return "Non définie";
  return new Date(dateString).toLocaleDateString('fr-FR');
};

// Fonction pour obtenir la classe de statut
const getStatusClass = (status) => {
  switch (status) {
    case "active": return "status-green";
    case "closed": return "status-red";
    case "draft": return "status-yellow";
    default: return "status-gray";
  }
};

const Row = ({
  item,
  value,
  onChange,
  activeTable,
  setActiveTable,
  activeId,
  setActiveId,
}) => {
  const navigate = useNavigate();

  const handleRowClick = async () => {
    setActiveId?.(item.id);

    try {
      // Récupérer les données complètes de l'offre avant de naviguer
      const result = await getOfferById(item.id);
      if (result.success && result.data) {
        navigate(`/company/alternance-offers/${item.id}`, { state: { offer: result.data } });
      } else {
        // Naviguer avec les données partielles si l'API échoue
        navigate(`/company/alternance-offers/${item.id}`, { state: { offer: item } });
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des données de l\'offre:', error);
      // Naviguer quand même avec les données partielles
      navigate(`/company/alternance-offers/${item.id}`, { state: { offer: item } });
    }
  };

  return (
    <>
      <div
        className={cn(
          styles.row,
          { [styles.selected]: activeId === item.id },
          { [styles.active]: activeTable }
        )}
        onClick={handleRowClick}
        style={{ cursor: 'pointer' }}
      >
        <div className={styles.col} onClick={(e) => e.stopPropagation()}>
          <Checkbox
            className={styles.checkbox}
            value={value}
            onChange={onChange}
          />
        </div>

        <div className={styles.col} onClick={handleRowClick}>
          <div className={styles.item}>
            <div className={styles.avatar}>
              <img src={'/images/content/convention_logo.png'} alt="Logo Offre" />
            </div>
            <div className={styles.details}>
              <div className={styles.user}>{item.title}</div>
              <div className={styles.login}>
                {item.type_contrat || "Type non défini"}
              </div>
            </div>
          </div>
        </div>

        <div className={styles.col}>
          {item.job_location || "Non défini"}
        </div>
        <div className={styles.col}>
          {formatDate(item.start_date)}
        </div>
        <div className={styles.col}>
          <span className={getStatusClass(item.status)}>
            {item.formattedStatus || item.status}
          </span>
        </div>
        <div className={styles.col}>
          <span className={getStatusClass(item.status)}>
            {item.formattedStatus || item.status}
          </span>
        </div>
        <div className={styles.col}>
          <span className="status-blue">
            {item.candidatesCount || 0} candidature{item.candidatesCount > 1 ? 's' : ''}
          </span>
        </div>
      </div>
    </>
  );
};

export default Row;